import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

const ImagensCarousel = () => {
  const imagens = [
    { src: "/FotoConsulta1.jpeg" },
    { src: "/FotoConsulta2.jpeg" },
    { src: "/FotoConsulta3.jpeg" },
    { src: "/FotoConsulta4.jpeg" },
  ];

  return (
    <div className="max-w-screen mx-auto mt-8 w-full">
      <div className="carousel-container-wrapper">
        <Carousel
          showArrows={true}
          showThumbs={false}
          infiniteLoop={true}
          autoPlay={true}
          interval={3000}
          transitionTime={500}
          dynamicHeight={false} // Desative dynamicHeight para controlar o height manualmente
          showStatus={false}
          stopOnHover={true}
          className="flex items-center justify-center carousel-root"
        >
          {imagens.map((imagem, index) => (
            <div key={index} className="carousel-slide h-24 w-full flex justify-center items-center bg-gray-200 rounded-md overflow-hidden">
              <img
                src={imagem.src}
                alt={`Imagem ${index + 1}`}
                className="w-full h-24 min-h-full min-w-full object-cover"
              />
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default ImagensCarousel;